<template>
    <MasterTemplate 
        title="ข้อมูลพนักงาน" 
        :headers="headers" 
        :setData="setData"
        itemKey="empId"
        :getItemName="getItemName"
        :deleteData="deleteData"
        :insertData="insertData"
        :updateData="updateData"
        :listData="listData"
        :onOpenDialog="onOpenDialog"
        >
        <template v-slot:formInput="{rules}">
            <v-row>
                <v-col cols="6" >
                    <v-autocomplete
                        v-model="editedItem.branchCode"
                        label="สาขา"
                        :items="branchs"
                        item-text="branchName"
                        item-value="branchCode"
                        @change="onBranchChange"
                        :rules="[rules.required]"
                        outlined
                    >
                    </v-autocomplete>
                </v-col>
                <v-col cols="6" >
                    <v-text-field outlined placeholder=" " label="รหัสพนักงาน" autofocus maxlength="8" v-model="editedItem.empCode" :rules="[rules.required, chkCode]"></v-text-field>
                </v-col>
                
            </v-row>
            <v-row>
                <v-col cols="4">
                    <v-radio-group v-model="editedItem.gender" row>
                    <v-radio label="ชาย" value="M"></v-radio>
                    <v-radio label="หญิง" value="F"></v-radio>
                    </v-radio-group>
                </v-col>
                <v-col cols="4" >
                    <v-text-field  outlined placeholder=" " label="ชื่อ" maxlength="50" v-model="editedItem.firstName" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="4" >
                    <v-text-field  outlined placeholder=" " label="นามสกุล" maxlength="50" v-model="editedItem.lastName" :rules="[rules.required]"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6" >
                    <v-autocomplete
                        v-model="editedItem.positionCode"
                        label="ตำแหน่ง"
                        :items="positions"
                        item-text="name"
                        item-value="value"
                        outlined
                        :rules="[rules.required]"
                    >
                    </v-autocomplete>
                </v-col>
                <v-col cols="6" >
                    <v-text-field  outlined placeholder=" " label="เบอร์โทร" v-model="editedItem.phone"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6" >
                    <v-text-field type="number" outlined placeholder=" " :rules="[rules.required]"  label="ค่าแรง / ต่อนาที" v-model="editedItem.wagePerMin"></v-text-field>
                </v-col>
                <v-col cols="6" >
                    <v-text-field label="Email" outlined placeholder=" " maxlength="50" v-model="editedItem.email"></v-text-field>
                </v-col>
            </v-row>
        </template>
    </MasterTemplate>
</template>

<script>
/* eslint-disable */
import MasterTemplate from '@/components/MasterTemplate'
import {listPositions, listEmployee, isExistEmployeeCode, insert, update, deleteEmployee} from '@/api/master/employee-api.js'
import {listBranch} from '@/api/master/branch-api.js'

export default {
    name: 'Employee',
    components: {
        MasterTemplate
    },
    computed: {
        chkCode() {
            if (this.isDup == true) return 'รหัสพนักงานซ้ำ';
            return true;
        }
    },
    watch: {
        'editedItem.empCode': function(newVal, oldVal) {
            if (!this.editedItem.empId) {
                this.editedItem.empId = '-1';
            }
            if (newVal && this.editedItem.empId) {
                isExistEmployeeCode(this.editedItem.branchCode, newVal, this.editedItem.empId).then(response => {
                    this.isDup = response;
                }).catch(e => {
                    this.isDup = false;
                });
            }
        }
    },
    data: () => ({
        isDup: false,
        headers: [
            {text: 'รหัสพนักงาน', value: 'empCode'},
            {text: 'ชื่อ-สกุล', value: 'fullname'},
            {text: 'ตำแหน่ง', value: 'positionName'},
            {text: 'สาขา', value: 'branchName'},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        editedItem: {
            empId: '-1',
            empCode: '',
            gender: 'M',
            firstName: '',
            lastName: '',
            phone: '',
            branchCode: '',
            positionCode: '',
            wagePerMin: '',
            email: ''
        },
        branchs: [],
        positions: []
    }),
    methods: {
        onOpenDialog(isNew) {
            if (isNew) {
                this.editedItem.branchCode = "A001";
                console.log(this.editedItem);
            }
        },
        onBranchChange() {
            this.editedItem.empCode = '';
        },
        listData() {
            return listEmployee()
        },
        deleteData(item) {
            return deleteEmployee(item.empId);
        },
        insertData() {
            return insert(this.editedItem);
        },
        updateData() {
            return update(this.editedItem);
        },
        getItemName(item) {
            return item.empCode;
        },
        setData(item) {
            this.editedItem = item;
        }
    },
    mounted() {
        listBranch().then(rs => {
            this.branchs = rs;
        });
        listPositions().then(rs => {
            this.positions = rs;
        });
    }
}
</script>
